<app-global-loading *ngIf="loading"></app-global-loading>
<div class="panel">
  <div class="title">创建新的工单</div>
  <div class="subtitle">
    在提交工单时，请提交所有可能有用的信息，例如帐户信息和错误截图等 <br />
    人工处理时间为8:00-24:00
  </div>
  <div class="divider"><p></p></div>
  <div class="panel-content" [formGroup]="formGroup">
    <div class="item">
      <div class="question"><span>*</span>选择您的订阅</div>
      <div class="answer">
        <app-subscription-select
          formControlName="subscription"
          (ngModelChange)="onValueChange($event)"
        ></app-subscription-select>
      </div>
    </div>
    <div class="item">
      <div class="question"><span>*</span>选择问题类别</div>
      <div class="answer">
        <app-issue-category-select
          [platform]="seat?.bus.platform.name"
          formControlName="issue"
          [(problem)]="problem"
        ></app-issue-category-select>
      </div>
      <ng-container *ngIf="problem">
        <div
          class="link"
          *ngIf="problem.help_link"
          (click)="checkProblemHelp()"
        >
          点击前往帮助中心查看解决方案
        </div>
      </ng-container>
    </div>
    <!-- <div class="item" *ngIf="formGroup.value['issue'] !== ''">
    <div class="question"><span>*</span>具体问题</div>
    <div class="answer">
      <app-issue-category2-select
        [problems]="problems2"
        formControlName="issue2"
      ></app-issue-category2-select>
    </div>
  </div> -->
    <app-special-question-panel></app-special-question-panel>
    <div class="item">
      <div class="question">问题详情</div>
      <div class="answer">
        <textarea formControlName="detail"></textarea>
        <app-image-uploader-qiniu
          formControlName="image"
          width="250px"
          height="100px"
          [ratio]="2.5"
        ></app-image-uploader-qiniu>
      </div>
    </div>
    <div class="error" *ngIf="error">* 是必须的</div>
    <div class="button">
      <button matRipple (click)="submit()">提交</button>
    </div>
  </div>
</div>
